"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var service_service_1 = require("./../Services/service.service");
var core_1 = require("@angular/core");
var BuyBanerComponent = /** @class */ (function () {
    function BuyBanerComponent(service, route) {
        this.service = service;
        this.route = route;
    }
    BuyBanerComponent.prototype.ngOnInit = function () {
        this.service.hideLoader(true);
    };
    BuyBanerComponent.prototype.onTokenAdded = function (response) {
        var _this = this;
        if (response.isError) {
            this.service.showError(response.message ? response.message : "Payment process error.");
        }
        else {
            this.service.showInformation('Your banner ad has been added for the next month.');
            setTimeout(function () { _this.service.route.navigate(["/"]); }, 2000);
        }
    };
    return BuyBanerComponent;
}());
exports.BuyBanerComponent = BuyBanerComponent;
